import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _jsx from "@babel/runtime/helpers/jsx";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["totalCount", "filledCount"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

import React, { memo } from 'react';
import { Wrapper, List, StarIcon } from './styles';
import { jsxs as _jsxs } from "react/jsx-runtime";

var StarsList = function StarsList(_ref) {
  var totalCount = _ref.totalCount,
      filledCount = _ref.filledCount,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/_jsxs(Wrapper, _objectSpread(_objectSpread({}, props), {}, {
    children: [/*#__PURE__*/_jsx(List, {}, void 0, Array.from({
      length: totalCount
    }).map(function (item, index) {
      return /*#__PURE__*/_jsx(StarIcon, {
        "data-filled": false,
        name: "star",
        //eslint-disable-line
        "data-rating": index + 1
      }, index);
    })), /*#__PURE__*/_jsx(List, {
      style: {
        overflow: 'hidden',
        width: "".concat(filledCount / totalCount * 100, "%")
      }
    }, void 0, Array.from({
      length: totalCount
    }).map(function (item, index) {
      return /*#__PURE__*/_jsx(StarIcon, {
        "data-filled": true,
        name: "star"
      }, index);
    }))]
  }));
};

StarsList.defaultProps = {
  totalCount: 1,
  filledCount: 1
};
export default /*#__PURE__*/memo(StarsList);